// development
//export const API_AUTH = 'http://127.0.0.1:5000/api/auth/';
//export const API_GUEST = 'http://127.0.0.1:5000/api/guest/';

// production
export const API_AUTH = "https://new-api.suwaarana.org/api/auth/";
export const API_GUEST = "https://new-api.suwaarana.org/api/guest/";

export const HORIZONTAL_MAX_ITEM = 7;

export const MenuOrientation = {
  VERTICAL: "vertical",
  HORIZONTAL: "horizontal",
};

export const ThemeMode = {
  LIGHT: "light",
  DARK: "dark",
};

export const ThemeDirection = {
  LTR: "ltr",
  RTL: "rtl",
};

const config = {
  menuOrientation: MenuOrientation.VERTICAL,
  miniDrawer: false,
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 8,
  outlinedFilled: true,
  mode: ThemeMode.LIGHT,
  presetColor: "default",
  i18n: "en",
  themeDirection: ThemeDirection.LTR,
  container: false,
};

export default config;
